import { FormControl, FormGroup, Validators } from '@angular/forms';
import { emailValidator } from '../../../validators/email.validator';

export type ForgotPasswordFormGroup = FormGroup<{
  email: FormControl<string>;
}>;

export function createForgotPasswordFormGroup(): ForgotPasswordFormGroup {
  return new FormGroup({
    email: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, emailValidator]
    })
  });
}
